import React, { PropsWithChildren } from 'react';

import { isDisabled } from 'app/infrastructure/data/date';
import { isDefinedIncludingZero } from 'app/infrastructure/data/number';
import { Tag } from 'app/components/tag';
import { ExternalUrlItem } from 'app/area/external-url-groups/form/types-store';
import styles from './external-url-tile-header.scss';

export const ExternalUrlTileHeader = ({
  externalUrlItem, canDrag, disabledLabel
}: PropsWithChildren<{
  externalUrlItem: ExternalUrlItem;
  canDrag: boolean;
  disabledLabel: string;
}>) => {

  return !!externalUrlItem && <>
    {canDrag && <div className={styles.dragSymbol} />}
    {isDefinedIncludingZero(externalUrlItem.code?.value)
      && <div className={styles.tileId}>
        #{externalUrlItem.code?.value}
      </div>}
    <h3 className={styles.tileTitle}>{externalUrlItem.code?.description}</h3>
    {isDisabled(externalUrlItem.disabled)
      ? <Tag className={styles.disabledTag}>
        {disabledLabel}
      </Tag>
      : null}
  </>;
};
